module.exports = __webpack_public_path__ + "img/ELandcarleton.4ed28aed.png";